(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DRAG_THRESHOLD = 6;

    /**
     * Mouse/pointer drag-to-scroll for horizontal product carousels.
     * Touch already works via native overflow scrolling.
     * @param {HTMLElement} scroller
     */
    const bindDragScroll = (scroller) => {
      if (!(scroller instanceof HTMLElement) || scroller.dataset.sbpDragBound === 'true') return;
      scroller.dataset.sbpDragBound = 'true';

      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let dragging = false;
      let didDrag = false;

      const canScroll = () => scroller.scrollWidth > scroller.clientWidth + 1;

      const onPointerDown = (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (!canScroll()) return;

        const target = event.target;
        if (!(target instanceof Element)) return;
        // Let form controls keep normal mouse behavior.
        if (target.closest('input, textarea, select, label')) return;

        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        dragging = false;
        didDrag = false;
      };

      const onPointerMove = (event) => {
        if (pointerId !== event.pointerId) return;

        const deltaX = event.clientX - startX;

        if (!dragging) {
          if (Math.abs(deltaX) < DRAG_THRESHOLD) return;
          dragging = true;
          didDrag = true;
          scroller.classList.add('is-dragging');
          try {
            scroller.setPointerCapture(event.pointerId);
          } catch {
            // Ignore capture failures.
          }
        }

        event.preventDefault();
        scroller.scrollLeft = startScrollLeft - deltaX;
      };

      const endDrag = (event) => {
        if (pointerId == null) return;
        if (event && event.pointerId != null && event.pointerId !== pointerId) return;

        if (dragging) {
          scroller.classList.remove('is-dragging');
          try {
            if (scroller.hasPointerCapture?.(pointerId)) {
              scroller.releasePointerCapture(pointerId);
            }
          } catch {
            // Ignore release failures.
          }
        }

        pointerId = null;
        dragging = false;
      };

      const onClickCapture = (event) => {
        if (!didDrag) return;
        didDrag = false;
        event.preventDefault();
        event.stopPropagation();
      };

      scroller.addEventListener('pointerdown', onPointerDown);
      scroller.addEventListener('pointermove', onPointerMove);
      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
      scroller.addEventListener('lostpointercapture', endDrag);
      scroller.addEventListener('click', onClickCapture, true);
    };

    const roots = document.querySelectorAll('[data-shop-by-product]');

    roots.forEach((root) => {
      if (root.dataset.sbpBound === 'true') return;
      root.dataset.sbpBound = 'true';

      const tabs = root.querySelectorAll('[data-shop-by-product-tab]');
      const panels = root.querySelectorAll('[data-shop-by-product-panel]');
      const scrollers = root.querySelectorAll('[data-shop-by-product-scroller]');

      scrollers.forEach((scroller) => bindDragScroll(scroller));

      // Single collection: no tabs rendered, just make sure the only panel is visible.
      if (!tabs.length) {
        panels.forEach((panel) => {
          panel.hidden = false;
        });
        return;
      }

      const showPanel = (panelId) => {
        panels.forEach((panel) => {
          const match = panel.getAttribute('data-shop-by-product-panel') === panelId;
          panel.hidden = !match;
          if (match) {
            const scroller = panel.querySelector('[data-shop-by-product-scroller]');
            if (scroller) scroller.scrollLeft = 0;
          }
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((other) => {
            const isActive = other === tab;
            other.classList.toggle('is-active', isActive);
            other.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          showPanel(tab.getAttribute('data-panel-id'));
        });
      });

      showPanel(tabs[0].getAttribute('data-panel-id'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
